const actionTypes = {
  // CONFIG 관련 액션
  LOGIN_CHECK: "CONFIG/LOGIN_CHECK",
  LOGIN_CHECK_SUCCEED: "CONFIG/LOGIN_CHECK_SUCCEED",
  LOGIN_CHECK_FAILED: "CONFIG/LOGIN_CHECK_FAILED",
  LOGIN_INFO_APPROVAL: "CONFIG/LOGIN_INFO_APPROVAL",
  LOGOUT_ON: "CONFIG/LOGOUT_ON",
  LOGOUT_ON_RESULT: "CONFIG/LOGOUT_ON_RESULT",

  // MENU 관련 액션
  MENU_ON: "MENU/MENU_ON",
  MENU_ON_RESULT: "MENU/MENU_ON_RESULT",
  MENU_CLICK: "MENU/MENU_CLICK",
  MENU_CLICK_RESULT: "MENU/MENU_CLICK_RESULT",

  // YOUTUBE 관련 액션
  YOUTUBE_ON: "YOUTUBE/YOUTUBE_ON",
  YOUTUBE_ON_RESULT: "YOUTUBE/YOUTUBE_ON_RESULT",

  // BOARD 관련 액션 (게시판 목록)
  BOARD_FETCH: "BOARD_FETCH",
  BOARD_FETCH_SUCCEED: "BOARD_FETCH_SUCCEED",
  BOARD_FETCH_FAILED: "BOARD_FETCH_FAILED",
  BOARD_RESET: "BOARD/BOARD_RESET",

  // BOARD 관련 액션 (게시판 상세)
  BOARD_DETAIL_FETCH: "BOARD_DETAIL_FETCH",
  BOARD_DETAIL_FETCH_SUCCEED: "BOARD_DETAIL_FETCH_SUCCEED",
  BOARD_DETAIL_FETCH_FAILED: "BOARD_DETAIL_FETCH_FAILED",
  BOARD_DETAIL_RESET: "BOARD_DETAIL_RESET",
  BOARD_DETAIL_RESET_SUCCEED: "BOARD/BOARD_DETAIL_RESET_SUCCEED",
  BOARD_DETAIL_RESET_FAILED: "BOARD/BOARD_DETAIL_RESET_FAILED",

  // BOARD 관련 액션 (게시판 작성)
  BOARD_WRITE: "BOARD_WRITE",
  BOARD_WRITE_SUCCEED: "BOARD_WRITE_SUCCEED",
  BOARD_WRITE_FAILED: "BOARD_WRITE_FAILED",
  BOARD_WRITE_RESET: "BOARD/BOARD_WRITE_RESET",
  BOARD_WRITE_RESET_SUCCEED: "BOARD/BOARD_WRITE_RESET_SUCCEED",
  BOARD_WRITE_RESET_FAILED: "BOARD/BOARD_WRITE_RESET_FAILED",

  // BOARD 관련 액션 (게시판 수정)
  BOARD_UPDATE: "BOARD_UPDATE",
  BOARD_UPDATE_SUCCEED: "BOARD_UPDATE_SUCCEED",
  BOARD_UPDATE_FAILED: "BOARD_UPDATE_FAILED",
  BOARD_UPDATE_RESET: "BOARD_UPDATE_RESET",

  // BOARD 관련 액션 (게시판 삭제)
  BOARD_DELETE: "BOARD_DELETE",
  BOARD_DELETE_SUCCEED: "BOARD_DELETE_SUCCEED",
  BOARD_DELETE_FAILED: "BOARD_DELETE_FAILED",

  // USER 관련 액션 (사용자 정보)
  USER_INFO_FETCH: "USER/USER_INFO_FETCH",
  USER_INFO_FETCH_SUCCEED: "USER/USER_INFO_FETCH_SUCCEED",
  USER_INFO_FETCH_FAILED: "USER/USER_INFO_FETCH_FAILED",

  // USER 관련 액션 (사용자 정보 입력)
  USER_INFO_INPUT_FETCH: "USER/USER_INFO_INPUT_FETCH",
  USER_INFO_INPUT_FETCH_SUCCEED: "USER/USER_INFO_INPUT_FETCH_SUCCEED",
  USER_INFO_INPUT_FETCH_FAILED: "USER/USER_INFO_INPUT_FETCH_FAILED",

  // USER 관련 액션 (사용자 정보 업데이트)
  USER_INFO_UPDATE: "USER/USER_INFO_UPDATE",
  USER_INFO_UPDATE_SUCCEED: "USER/USER_INFO_UPDATE_SUCCEED",
  USER_INFO_UPDATE_FAILED: "USER/USER_INFO_UPDATE_FAILED",

  // CLUB 관련 액션 (동아리 전용)
  CLUB_FETCH: "CLUB/CLUB_FETCH",
  CLUB_FETCH_SUCCEED: "CLUB/CLUB_FETCH_SUCCEED",
  CLUB_FETCH_FAILED: "CLUB/CLUB_FETCH_FAILED",

  CLUB_DETAIL_FETCH: "CLUB/CLUB_DETAIL_FETCH",
  CLUB_DETAIL_FETCH_SUCCEED: "CLUB/CLUB_DETAIL_FETCH_SUCCEED",
  CLUB_DETAIL_FETCH_FAILED: "CLUB/CLUB_DETAIL_FETCH_FAILED",
  CLUB_DETAIL_RESET: "CLUB/CLUB_DETAIL_RESET",

  CLUB_WRITE: "CLUB/CLUB_WRITE",
  CLUB_WRITE_SUCCEED: "CLUB/CLUB_WRITE_SUCCEED",
  CLUB_WRITE_FAILED: "CLUB/CLUB_WRITE_FAILED",
  CLUB_WRITE_RESET: "CLUB/CLUB_WRITE_RESET",

  CLUB_UPDATE: "CLUB/CLUB_UPDATE",
  CLUB_UPDATE_SUCCEED: "CLUB/CLUB_UPDATE_SUCCEED",
  CLUB_UPDATE_FAILED: "CLUB/CLUB_UPDATE_FAILED",
  CLUB_UPDATE_RESET: "CLUB/CLUB_UPDATE_RESET",

  CLUB_DELETE: "CLUB/CLUB_DELETE",
  CLUB_DELETE_SUCCEED: "CLUB/CLUB_DELETE_SUCCEED",
  CLUB_DELETE_FAILED: "CLUB/CLUB_DELETE_FAILED",

  // NEWS 관련 액션 (교회 소식)
  NEWS_FETCH: "NEWS/NEWS_FETCH",
  NEWS_FETCH_SUCCEED: "NEWS/NEWS_FETCH_SUCCEED",
  NEWS_FETCH_FAILED: "NEWS/NEWS_FETCH_FAILED",

  NEWS_DETAIL_FETCH: "NEWS/NEWS_DETAIL_FETCH",
  NEWS_DETAIL_FETCH_SUCCEED: "NEWS/NEWS_DETAIL_FETCH_SUCCEED",
  NEWS_DETAIL_FETCH_FAILED: "NEWS/NEWS_DETAIL_FETCH_FAILED",

  NEWS_WRITE: "NEWS/NEWS_WRITE",
  NEWS_WRITE_SUCCEED: "NEWS/NEWS_WRITE_SUCCEED",
  NEWS_WRITE_FAILED: "NEWS/NEWS_WRITE_FAILED",

  NEWS_UPDATE: "NEWS/NEWS_UPDATE",
  NEWS_UPDATE_SUCCEED: "NEWS/NEWS_UPDATE_SUCCEED",
  NEWS_UPDATE_FAILED: "NEWS/NEWS_UPDATE_FAILED",

  NEWS_DELETE: "NEWS/NEWS_DELETE",
  NEWS_DELETE_SUCCEED: "NEWS/NEWS_DELETE_SUCCEED",
  NEWS_DELETE_FAILED: "NEWS/NEWS_DELETE_FAILED",

  // WEEKLY 관련 액션 (주보)
  WEEKLY_FETCH: "WEEKLY/WEEKLY_FETCH",
  WEEKLY_FETCH_SUCCEED: "WEEKLY/WEEKLY_FETCH_SUCCEED",
  WEEKLY_FETCH_FAILED: "WEEKLY/WEEKLY_FETCH_FAILED",

  WEEKLY_DETAIL_FETCH: "WEEKLY/WEEKLY_DETAIL_FETCH",
  WEEKLY_DETAIL_FETCH_SUCCEED: "WEEKLY/WEEKLY_DETAIL_FETCH_SUCCEED",
  WEEKLY_DETAIL_FETCH_FAILED: "WEEKLY/WEEKLY_DETAIL_FETCH_FAILED",

  WEEKLY_WRITE: "WEEKLY/WEEKLY_WRITE",
  WEEKLY_WRITE_SUCCEED: "WEEKLY/WEEKLY_WRITE_SUCCEED",
  WEEKLY_WRITE_FAILED: "WEEKLY/WEEKLY_WRITE_FAILED",

  WEEKLY_UPDATE: "WEEKLY/WEEKLY_UPDATE",
  WEEKLY_UPDATE_SUCCEED: "WEEKLY/WEEKLY_UPDATE_SUCCEED",
  WEEKLY_UPDATE_FAILED: "WEEKLY/WEEKLY_UPDATE_FAILED",

  WEEKLY_DELETE: "WEEKLY/WEEKLY_DELETE",
  WEEKLY_DELETE_SUCCEED: "WEEKLY/WEEKLY_DELETE_SUCCEED",
  WEEKLY_DELETE_FAILED: "WEEKLY/WEEKLY_DELETE_FAILED",

  // COMMON 관련 액션 (공통)
  LOADING_START: "COMMON/LOADING_START",
  LOADING_END: "COMMON/LOADING_END",
  ERROR_SET: "COMMON/ERROR_SET",
  ERROR_CLEAR: "COMMON/ERROR_CLEAR",

  // SEARCH 관련 액션 (검색)
  SEARCH_SET_KEYWORD: "SEARCH/SEARCH_SET_KEYWORD",
  SEARCH_CLEAR: "SEARCH/SEARCH_CLEAR",

  // PAGINATION 관련 액션 (페이지네이션)
  PAGINATION_SET_PAGE: "PAGINATION/PAGINATION_SET_PAGE",
  PAGINATION_SET_SIZE: "PAGINATION/PAGINATION_SET_SIZE",
  PAGINATION_RESET: "PAGINATION/PAGINATION_RESET",
}

export default actionTypes
